/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Link } from 'react-router-dom'

// import LogoArtlingProjectsSvg from '../../static/LogoArtlingProjects.svg'
import LogoArtlingProjectsSvg from '../../static/LogoArtlingProjectsBeta.svg'

interface Props {
  width?: string
  publicLink?: boolean
}

const Logo: React.FC<Props> = (props) => {
  const { width, publicLink = false } = props
  const link = publicLink ? '/' : '/en/u/'
  return (
    <Link to={link} style={{ textDecoration: 'none' }}>
      <img
        src={LogoArtlingProjectsSvg}
        css={{ width: width ? width : '100px' }}
      />
    </Link>
  )
}

export default Logo
